export default __webpack_public_path__ + "static/media/SansWeb-Regular.0166af99.woff";